const colors = {
    primary: 'this:primary',
    secondary: 'this:secondary',
    info: 'this:info',
    success: 'this:success',
    warning: 'this:warning',
    error: 'this:error',
    auto: 'this:auto',
    neutral: 'this:neutral', 
};

/**
 * Returns the class name for the specified color.
 *
 * @param {string} color - The color key to look up.
 * @returns {string} - The corresponding class name for the color.
 * @throws {Error} - Throws an error if the color is not found in the color map.
 */
export function setThisClass(color) {
    // Allow falsy values
    if (!color) return "";

    // If color is a known semantic key, return its mapped value
    const className = colors[color];
    if (className) return className;

    // If caller passed a raw Tailwind utility class (e.g. 'bg-gray-500', 'text-green-600'),
    // accept it as-is instead of throwing. Detect by presence of a dash (common in utility classes)
    if (typeof color === "string" && color.includes("-")) {
        return color;
    }

    // As a final fallback, return the input value to avoid breaking rendering.
    return color;
}
